import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDw4eHKnt2otRsyByJEJeRc2o5y8W8IZS4",
    authDomain: "attributed.firebaseapp.com",
    projectId: "attributed",
    storageBucket: "attributed.firebasestorage.app",
    messagingSenderId: "896466986185",
    appId: "1:896466986185:web:4a057a5e0412b962f7d918",
    measurementId: "G-9116EW96TN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase services
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);
const auth = getAuth(app);

export {
    app,
    db,
    storage,
    functions,
    auth
}